import React from 'react'
import PropTypes from 'prop-types'
import { Container } from 'reactstrap'

const MyAccountLink = ({ handleP360Redirect }) => {
  return (
    <Container>
      <span
        className="btn-link pointer"
        onClick={handleP360Redirect}
        data-test="links.my-account-redirect"
      >
        Return to Pocket360®
      </span>
    </Container>
  )
}

MyAccountLink.propTypes = {
  handleP360Redirect: PropTypes.func.isRequired,
}

export default MyAccountLink
